import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  IconButton,
  Button,
  Paper,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";

const ExpirationIntervals = () => {
  const [intervals, setIntervals] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editValue, setEditValue] = useState("");

  useEffect(() => {
    fetchIntervals();
  }, []);

  const fetchIntervals = async () => {
    try {
      const token = localStorage.getItem("adminToken");
      const res = await fetch("https://api.egosaferelationship.com/admin/expirations", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await res.json();
      setIntervals(data);
    } catch (err) {
      console.error("Failed to fetch expiration intervals:", err);
    }
  };

  const handleEdit = (id, currentValue) => {
    setEditingId(id);
    setEditValue(currentValue.toString());
  };

  const handleSave = async (id) => {
    try {
      const token = localStorage.getItem("adminToken");
      const res = await fetch(
        `https://api.egosaferelationship.com/admin/expirations/${id}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ days_interval: parseInt(editValue, 10) }),
        }
      );
      if (res.ok) {
        fetchIntervals();
        setEditingId(null);
        setEditValue("");
      } else {
        const errData = await res.json();
        alert(errData.error || "Failed to update interval.");
      }
    } catch (err) {
      console.error("Error updating interval:", err);
    }
  };

  return (
    <Box p={3} component={Paper}>
      <Typography variant="h4" mb={2}>
        Expiration Intervals
      </Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Type</TableCell>
            <TableCell>Interval (Days)</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {intervals.map((interval) => (
            <TableRow key={interval.id}>
              <TableCell>{interval.type_name}</TableCell>
              <TableCell>
                {editingId === interval.id ? (
                  <TextField
                    value={editValue}
                    onChange={(e) => setEditValue(e.target.value)}
                    type="number"
                    size="small"
                  />
                ) : (
                  interval.days_interval
                )}
              </TableCell>
              <TableCell>
                {editingId === interval.id ? (
                  <>
                    <IconButton onClick={() => handleSave(interval.id)}>
                      <SaveIcon />
                    </IconButton>
                    <IconButton
                      onClick={() => {
                        setEditingId(null);
                        setEditValue("");
                      }}
                    >
                      <CancelIcon />
                    </IconButton>
                  </>
                ) : (
                  <IconButton
                    onClick={() =>
                      handleEdit(interval.id, interval.days_interval)
                    }
                  >
                    <EditIcon />
                  </IconButton>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Box mt={3}>
        <Button
          variant="contained"
          onClick={() => (window.location.href = "/users")}
        >
          Back to User Management
        </Button>
      </Box>
    </Box>
  );
};

export default ExpirationIntervals;
